<template>
  <div class="layout-app">
    <Header />
    <div class="layout-body">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import api from './api';

export default {
  components: { Header, Footer },
  data() {
    return {
  inactivityTimer: null,
  // Incrementar a 3 horas para coincidir con la política central
  inactivityLimit: 3 * 60 * 60 * 1000, // 3 horas
    };
  },
  mounted() {
    this.startInactivityTimer();
    this.addActivityListeners();
  },
  beforeUnmount() {
    this.removeActivityListeners();
    if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
  },
  methods: {
    startInactivityTimer() {
      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(this.forceLogout, this.inactivityLimit);
    },
    resetInactivityTimer() {
      this.startInactivityTimer();
    },
    async forceLogout() {
      try {
        await api.post('/logout-forzado');
      } catch (e) {
        // Ignorar errores, continuar con logout local
      }
  sessionStorage.removeItem('auth_token');
  sessionStorage.removeItem('user_name');
  sessionStorage.removeItem('user_role');
      window.location.replace('/ticketagrovin/login');
    },
    addActivityListeners() {
      const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, this.resetInactivityTimer, true);
      });
    },
    removeActivityListeners() {
      const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.removeEventListener(event, this.resetInactivityTimer, true);
      });
    },
  },
};
</script>

<style>
.layout-app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.layout-body {
  flex: 1 1 auto;
  /* Evitar que el body general haga scroll: cada vista debe controlar su propio scroll interno
     (por ejemplo, WelcomeView puede tener .table-container con overflow-y:auto). */
  overflow-y: hidden;
  min-height: 0;
}
</style>
